import React from 'react';
import { MainContainerLayout } from 'clorian-frontend-components';
import ValidationContainer from '../containers/ValidationContainer';
import Header from '../components/structure/Header';
import Footer from '../components/structure/Footer';

const VerifierView = () => (
  <div>
    <Header />
    <MainContainerLayout>
      <ValidationContainer />
    </MainContainerLayout>
    <Footer />
  </div>
);

export default VerifierView;
